import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import { getListadoCotizaciones } from '../../api/apiConfig';
import { Card, SectionTitle } from './components';
import { clp, pct } from '../../utils/cotizadorEngine';

export default function ListadoCotizaciones() {
  const { user } = useUser();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        const data = await getListadoCotizaciones(user);
        setRows(data?.cotizaciones || data || []);
      } catch (e) {
        setError(e.message || 'Error al cargar listado');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [user]);

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Cotizaciones guardadas</h1>
          <p className="text-gray-600 text-sm">Historial del cotizador factoring</p>
        </div>
        <Link to="/cotizador-factoring" className="rounded-xl bg-blue-600 px-4 py-2 text-sm font-semibold text-white">
          Nueva cotización
        </Link>
      </div>

      <Card>
        {loading && <p className="text-gray-500">Cargando...</p>}
        {error && <p className="text-red-600">{error}</p>}
        {!loading && !error && rows.length === 0 && (
          <p className="text-gray-500">No hay cotizaciones guardadas.</p>
        )}
        {!loading && rows.length > 0 && (
          <div className="overflow-x-auto">
            <table className="w-full text-sm text-left">
              <thead className="bg-slate-100">
                <tr>
                  <th className="p-2">ID</th>
                  <th className="p-2">Fecha</th>
                  <th className="p-2">Ejecutivo</th>
                  <th className="p-2">Cliente</th>
                  <th className="p-2">Docs</th>
                  <th className="p-2">Deudor</th>
                  <th className="p-2">Clasif.</th>
                  <th className="p-2">Pre-eval</th>
                  <th className="p-2">Líquido</th>
                  <th className="p-2">Spread</th>
                  <th className="p-2">Margen</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.id} className="border-t border-slate-100">
                    <td className="p-2">{r.id}</td>
                    <td className="p-2">{r.creado_en || '—'}</td>
                    <td className="p-2">{r.ejecutivo || '—'}</td>
                    <td className="p-2">{r.nombre_cliente || r.rut_cliente_display || '—'}</td>
                    <td className="p-2">{r.cantidad_documentos ?? 1}</td>
                    <td className="p-2">{r.rut_deudor_display || '—'}</td>
                    <td className="p-2">{r.clasificacion_aplicada || '—'}</td>
                    <td className="p-2">{r.pre_evaluacion || '—'}</td>
                    <td className="p-2">{clp(r.monto_liquido)}</td>
                    <td className="p-2">{r.spread_real != null ? pct(r.spread_real) : '—'}</td>
                    <td className="p-2">{clp(r.margen_neto)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
}
